<template lang="pug">
List
</template>

<script>
import List from "./List/index";

export default {
  components: { List },
};
</script>